<template>
<div class="bk-blue-light">
    <img src="../../../assets/images/pentru-imunitate/vitamina-C.png" style="width: 54px; height: 54px">
    <h2>Vitamina C</h2>
    <p>este esențială pentru sistemul imunitar. Cele mai bune surse de vitamina C
        sunt: măceșele, cătina, portocalele, broccoli, kiwi, roșiile etc.
    </p>
</div>
</template>

<script>
export default {
    name: 'Vitamina-C',

    data() {
        return {}
    },
}
</script>
<style scoped lang="scss">
.bk-blue-light {
    background: #F2F0ED;
    border-radius: 20px;
    width: 458px !important;
    min-height: 270px;
    max-height: 270px;
    position: relative;
    @media only screen and (max-width: 992px) {
        width: 100% !important;
        min-height: 100%;
        max-height: 100%;
        margin-top: 15px;
    }

    &:focus {
        outline: none;
    }

    p {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }

    span {
        font-size: 16px;
        font-weight: 500;
        color: #029FE3;
    }
}
@media only screen and (max-width: 526px) {
  .bk-blue-light img{
    width: 54px;
    margin-left: 0;
  }
  .bk-blue-light{
    text-align: left;
    margin-right: 10px;
    width: 95% !important;
  }
}
</style>
